<template>
  <div class="md-layout text-center">
    <div class="md-layout-item" v-show="!imagesFiles">
      <md-empty-state md-icon="insert_photo" md-label="Upload meter images" md-description>
        <md-button class="md-success md-fileinput">
          <template>Select images</template>
          <input type="file" @change="onImageSelected" accept="image/*" multiple />
        </md-button>
      </md-empty-state>
    </div>

    <div class="md-layout-item" v-if="imagesFiles">
      <!-- <h4 class="info-text">Upload Successful</h4> -->
      <md-empty-state class="md-primary" md-icon="done" md-label="Images selected" md-description></md-empty-state>
    </div>

    <!-- <div class="md-layout-item" v-show="!imagesFiles">
        <h4 class="info-text">Add meter images</h4>
        <div class="file-input">
          <div class="image-container">
            <img src="/img/image_placeholder.jpg" title />
          </div>
          <div class="button-container">
            <md-button v-if="!imagesFiles" class="md-success md-fileinput">
              <template>Select images</template>
              <input type="file" @change="onImageSelected" accept="image/*" multiple />
            </md-button>

            <md-button v-if="imagesFiles" class="md-danger md-round" @click="restartToDefault">
              <i class="fa fa-times"></i>Remove
            </md-button>
          </div>
        </div>
    </div>-->

    <!-- <div class="md-layout-item" v-show="uploading">
        <h4 class="info-text">Uploading images...</h4>
        <md-progress-bar class="md-success" md-mode="indeterminate"></md-progress-bar>
    </div>-->

    <!-- <div class="md-layout-item" v-if="imagesFiles">
        <md-empty-state class="md-primary" md-icon="done" md-label="Images selected" md-description="">
          
       
                    <md-button v-if="imagesFiles" class="md-success md-fileinput">
              <template>Change</template>
              <input type="file" @change="onImageSelected" accept="image/*" multiple />
            </md-button>
 </md-empty-state>
                    <md-button v-if="imagesFiles" class="md-danger" @click="restartToDefault">
              <i class="fa fa-times"></i>Remove
            </md-button>
    </div>-->

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import snackBar from "@/components/SnackBar";

export default {
  components: {
    snackBar
  },
  data() {
    return {
      imagesFiles: ""
    };
  },

  methods: {
    restartToDefault() {
      this.imagesFiles = "";
    },

    onImageSelected(event) {
      const allowedImageTypes = ["image/png", "image/jpeg", "image/jpg"];

      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      let fileValidation = false;

      files.forEach(file => {
        if (!allowedImageTypes.includes(file.type)) {
          this.$refs.snackbar.notify(
            this.$lang.messages.file_format_not_supported
          );
          fileValidation = true;
        }

        //MAX 1MB
        if (file.size > 1000000) {
          this.$refs.snackbar.notify(this.$lang.messages.file_too_large);
          fileValidation = true;
        }
      });

      if (fileValidation) {
        return;
      }

      this.imagesFiles = event.target.files;
    },

    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit("on-validated", true, { images: this.imagesFiles }, true);
        }
        return res;
      });
    }
  }
};
</script>